import microuniversoApi from "app/api/microuniversoApi"
import { useAppSelector } from "app/redux/hooks"
import { Parametro } from "app/types/Parametro"
import { tratamentoErroPadrao } from "app/use-cases"
import { definirAdquirirQuantidadeTotalItem } from "app/use-cases/orcamento/definirAdquirirQuantidadeTotalItem"
import { obterParametros } from "app/use-cases/parametro/obterParametros"
import globalMU from "globalMU"
import React, { useEffect, useState } from "react"
import { DadosEncomenda } from "./DadosEncomenda"
import { ModalVendaSobEncomenda } from "./ModalVendaSobEncomenda"

export type ModalVendaSobEncomendaContainerProps = {
    onFecharCaixaDeDialogo: () => void
    onCancelarCaixaDeDialogo: () => void
    identificadorItem: number
    solicitacaoAberturaModalManual: boolean
}

export const ModalVendaSobEncomendaContainer = (props: ModalVendaSobEncomendaContainerProps) => {

     
    const [processando, setProcessando] = useState(true)
    const orcamento = useAppSelector(store => store.orcamento)
    const item = useAppSelector(store => (store.orcamento.ItensOrcamento ?? []).find(i => i.Identificador == props.identificadorItem))

    const [dadosEncomenda, setDadosEncomenda] = useState<DadosEncomenda>(null)

    const [parametros, setParametros] = useState<Parametro[]>([])

    const valorParametro = (nome:string) => (parametros ?? []).find(p => p.Nome == nome)?.Valor ?? ""

    const habilitarAdquirirQuantidadeTotal = () => {
        if (dadosEncomenda == null) {
            return false
        }
/*
        return valorParametro("TRATAR_VENDAS_SOB_ENCOMENDA") == "4" || dadosEncomenda.QuantidadeDisponivel <= 0 ? true :
                valorParametro("TRATAR_VENDAS_SOB_ENCOMENDA") != "4" && item.ProdutoEncomendaComprarTotal ? false :
                valorParametro("TRATAR_VENDAS_SOB_ENCOMENDA") != "4" && dadosEncomenda.QuantidadeDisponivel > 0 ? true : false
*/
        if (item.ProdutoEncomendaComprarTotal) {
            return false
        }
        if (dadosEncomenda.QuantidadeDisponivel <= 0)
        {            
            return false
        }

        return true
    }

    const atualizarParametros = async () => {
        setParametros(
            await obterParametros({
                nomes: [
                    'TRATAR_VENDAS_SOB_ENCOMENDA',
                    'ORCAMENTO_MASCARA_QUANTIDADE'
                ] 
            })
        )
    }

    const atualizarDadosEncomenda = async () => {
        setDadosEncomenda(
            await microuniversoApi.Orcamento.obterEncomendaItemOrcamento(orcamento.IdentificadorOrcamento, item.Identificador)   
        )
         
    }

    const aplicar = async (adquirirQuantidadeTotalItem: boolean) => {
        try {
            globalMU.blockUI()
            setProcessando(true)
 
            await definirAdquirirQuantidadeTotalItem({
                adquirirQuantidadeTotal: adquirirQuantidadeTotalItem,
                identificadorItem: props.identificadorItem,
                solicitacaoManual: props.solicitacaoAberturaModalManual
    
            })
        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI()
            setProcessando(false)
        }

        props.onFecharCaixaDeDialogo()
    }

    useEffect(() => {

        if (parametros == null || parametros.length == 0) {
            atualizarParametros()
        }

        if (item != null && dadosEncomenda == null)
        {
            atualizarDadosEncomenda()            
        }
        

        if (parametros != null && parametros.length > 0 && dadosEncomenda != null) {
            setProcessando(false)
        }
    },[item, parametros, dadosEncomenda])
    

    return <>
        {dadosEncomenda != null && <ModalVendaSobEncomenda
            onFecharCaixaDeDialogo={props.onFecharCaixaDeDialogo}
            onCancelarCaixaDeDialogo={props.onCancelarCaixaDeDialogo}
            dados={dadosEncomenda}
            processando={processando}
            habilitarAdquirirQuantidadeTotalItem={habilitarAdquirirQuantidadeTotal()}
            numeroCasasDecimaisQuantidade={globalMU.resolverNumeroCasasDecimaisDeParametroFormatado(valorParametro("ORCAMENTO_MASCARA_QUANTIDADE"))}
            onAplicar={aplicar}
            />}
    </>
}